import React from "react"

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { QueerifyStyles, InputStyles, SelectStyles } from "./styles"

import Canvas from "./Canvas"

const sizes = {
    "facebook": [
        {
            name: "Cover",
            size: "820x462"
        },
        {
            name: "Post oder Link",
            size: "1200x630"
        },
        {
            name: "Event Bild",
            size: "1920x1080"
        },
    ],
    "instagram": [
        {
            name: "Quadratisch",
            size: "1080x1080"
        },
        {
            name: "Story",
            size: "1080x1920"
        },
        {
            name: "IGTV Cover Photo",
            size: "420x654"
        }
    ]
}

const getSizeForLabel = (sizeName) => {
    let size = null;

    Object.keys(sizes).map(key => {
        Object.keys(sizes[key]).forEach(index => {
            const sizeObj = sizes[key][index];
            if (sizeObj.name === sizeName) {
                size = sizeObj
            }
        })
    })

    if (size && typeof size === "object") {
        const sizeParts = size.size.split("x");
        size = {
            width: sizeParts[0],
            height: sizeParts[1]
        }
    }

    return size;
}

const getSizesForPlatform = (platform) => {
    return sizes[platform];
}

const PlatformSize = ({ platform, handleChangeSize }) => {
    const classes = SelectStyles();
    const sizes = getSizesForPlatform(platform);
    const [sizeName, setSizeName] = React.useState("");

    return (
        <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="size-select-label">Größe</InputLabel>
            <Select
                labelId="size-select-label"
                id="size-select"
                value={sizeName}
                onChange={event => {
                    setSizeName(event.target.value);
                    handleChangeSize(event.target.value)
                }}
                label="Größe"
            >
                <MenuItem value=""><em>Keine Auswahl</em></MenuItem>
                {sizes.map(({ name }) => (
                    <MenuItem key={name} value={name}>{name}</MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

const CustomSize = ({ /* size,  */handleChangeSize }) => {
    const classes = InputStyles();

    const handleChangeCustomSize = (event) => {
        const newSize = {};
        newSize[event.target.name] = event.target.value
        handleChangeSize(newSize)
    }

    return (
        <form className={classes.root} noValidate autoComplete="off">
            <TextField id="custom-size-width" name="width" label="Breite (px)" variant="filled" onChange={handleChangeCustomSize} />
            <TextField id="custom-size-height" name="height" label="Höhe (px)" variant="filled" onChange={handleChangeCustomSize} />
        </form>
    )
}

const Queerify = () => {
    const stageRef = React.useRef(null);
    const classes = QueerifyStyles();
    const selectClasses = SelectStyles();
    const [image, setImage] = React.useState(null)
    const [platform, setPlatform] = React.useState('dynamic');
    const [size, setSize] = React.useState({
        width: 480,
        height: 360
    });

    const handleChangePlatform = (event) => {
        setPlatform(event.target.value);
    };

    const handleChangeSize = (value) => {
        let newSize = null;
        if (typeof value === "string") {
            newSize = getSizeForLabel(value)
        } else if (typeof value === "object") {
            newSize = value;
        }

        setSize(Object.assign({}, size, newSize));
    };

    const onImageLoad = (img) => {
        const maxWidth = window.innerWidth;
        const maxHeight = window.innerHeight;

        const ratio = (img.width > img.height ? (img.width / maxWidth) : (img.height / maxHeight))

        const height = img.height / ratio
        const width = img.width / ratio

        setSize({ width, height })
    }

    const onDownload = (event) => {
        const name = `${image.name}_qdf2_0.${image.extension}`
        const uri = stageRef.current.getStage().toDataURL();

        var link = document.createElement('a');
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <div className={classes.root}>
            <Grid container>
                <Grid item xs={12}>
                    <FormControl variant="outlined" className={selectClasses.formControl}>
                        <InputLabel id="platform-select-label">Plattform</InputLabel>
                        <Select
                            labelId="platform-select-label"
                            id="platform-select"
                            value={platform}
                            onChange={handleChangePlatform}
                            label="Plattform"
                        >
                            <MenuItem value={"dynamic"}>Dynamisch</MenuItem>
                            <MenuItem value={"instagram"}>Instagram</MenuItem>
                            <MenuItem value={"facebook"}>Facebook</MenuItem>
                        </Select>
                    </FormControl>

                    {platform === "dynamic" &&
                        <CustomSize handleChangeSize={handleChangeSize} />
                    }
                    {(platform === "instagram" || platform === "facebook") &&
                        <PlatformSize platform={platform} handleChangeSize={handleChangeSize} />
                    }
                </Grid>

                <Grid item xs={12}>
                    <Canvas ref={stageRef} size={size} onImageLoad={onImageLoad} setImage={setImage} image={image} />
                </Grid>

                <Grid item xs={12}>
                    <Button disabled={!image} size="large" color="primary" variant="contained" onClick={onDownload}>Download</Button>
                </Grid>
            </Grid>
        </div>
    )
}

export default Queerify